import { produce } from 'immer'
import { updateBudgetRouteProps } from 'src/navigation/routeProps'
import {
  PUT_CREDIT_CARD_FAILURE,
  PUT_CREDIT_CARD_INIT,
  PUT_CREDIT_CARD_SUCCESS,
  PutCreditCardActions,
} from 'src/redux/actions/data/creditCards.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import RecentUsersFullPaginatedDataReducer, {
  Actions as RecentUsersFullPaginatedDataActions,
  initialState as initialRecentUsersFullPaginatedDataState,
  RecentUsersFullPaginatedDataState,
} from 'src/redux/recentUsersFullPaginatedData.reducer'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface UpdateBudgetBaseState {
  puttingCreditCard: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialBaseState: UpdateBudgetBaseState = {
  puttingCreditCard: false,
}

export type BaseActions = PutCreditCardActions

const BaseUpdateBudgetReducer = (
  state = initialBaseState,
  action: BaseActions,
): UpdateBudgetBaseState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case PUT_CREDIT_CARD_INIT: {
        draft.puttingCreditCard = true
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }

      case PUT_CREDIT_CARD_SUCCESS: {
        draft.puttingCreditCard = false
        return draft
      }

      case PUT_CREDIT_CARD_FAILURE: {
        draft.puttingCreditCard = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

export type UpdateBudgetState = UpdateBudgetBaseState & {
  usersFullPaginatedData: UsersFullPaginatedDataState
  recentUsersFullPaginatedData: RecentUsersFullPaginatedDataState
}

export const initialState: UpdateBudgetState = {
  ...initialBaseState,
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
  recentUsersFullPaginatedData: initialRecentUsersFullPaginatedDataState,
}

export type Actions =
  | BaseActions
  | UsersFullPaginatedDataActions
  | RecentUsersFullPaginatedDataActions

const CoreUpdateBudgetReducer = (
  state = initialState,
  action: Actions,
): UpdateBudgetState => ({
  ...BaseUpdateBudgetReducer(state, action as BaseActions),
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
  recentUsersFullPaginatedData: RecentUsersFullPaginatedDataReducer(
    state.recentUsersFullPaginatedData,
    action as RecentUsersFullPaginatedDataActions,
  ),
})

const UpdateBudgetReducer = createFlyoutReducer(
  updateBudgetRouteProps,
  initialState,
  CoreUpdateBudgetReducer,
)

export default UpdateBudgetReducer
